document.addEventListener('click', (e) => {
  const btn = e.target.closest('.cart-ai-add');
  if (!btn) return;

  e.preventDefault();

  const variantId = btn.dataset.variant;
  if (!variantId) return;

  btn.disabled = true;
  btn.textContent = 'Adding…';

  const cart =
    document.querySelector('cart-drawer') ||
    document.querySelector('cart-notification');

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  if (cart) {
    formData.append(
      'sections',
      cart.getSectionsToRender().map(section => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }

  fetch(routes.cart_url, {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData
  })
    .then(res => res.json())
    .then(response => {
      if (response.status) {
        console.error(response);
        return;
      }

      /* ---------------------------
         EXACT SAME FLOW AS product-form.js
      ---------------------------- */

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'product-form',
        productVariantId: variantId,
        cartData: response
      });

      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(response);
      }

      // Force cart-items listeners (pricing, totals, shipping)
      fetch('/cart.js')
        .then(r => r.json())
        .then(cartData => {
          const cartItems =
            document.querySelector('cart-items') ||
            document.querySelector('cart-drawer-items');

          if (cartItems) {
            cartItems.updateShippingBar(cartData);
          }

          window.renderCartUpsell?.();
        });
    })
    .finally(() => {
      btn.disabled = false;
      btn.textContent = 'Add';
    });
});
